// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_DKA","cls2":"CiterightInline-cls2_rR- CiterightInline-cls1_DKA"};